<template>
  <block
    component-name="block-grid-collections"
    body-class="grid grid-cols-12 gap-x-ui gap-y-4xl"
  >
    <template v-slot:default="blockData">
      <card-collection
        v-for="(item, index) in $attrs.data.body.items"
        class="col-span-full w-full"
        :class="{
          'laptop:col-start-3 laptop:col-end-7': index % 2 == 0,
          'laptop:col-start-8 laptop:col-end-12': index % 2 != 0,
        }"
        :indoor="item.indoor"
        :outdoor="item.outdoor"
        :title="item.title"
        :text="item.text"
        :atelier="item.atelier || undefined"
        :resource="item.resource || undefined"
        :action="item.action"
        :asset="{
          ...item.asset,
          sizes: {
            base: 600,
            phablet: 1000,
            tablet: 1250,
            laptop: 800,
            desktop: 1000,
            extdesktop: 1400,
          },
          loading:
            blockData?.loading === 'lazy' || index > 3 ? 'lazy' : 'eager',
        }"
      />
    </template>
  </block>
</template>
